export default "__VITE_ASSET__CKmVn3Co__"